import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { DatePipe } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../components/table/table.component';
import { Observable, of, switchMap } from 'rxjs';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../environments/environment';
import { MyMonitoringService } from '../../services/logging.service';
import { DialogModule } from 'primeng/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { DistrictService } from '../../services/districtService';
import { AllRecordsService } from '../../services/allRecordsService';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ApiService } from '../../services/apiservice';
import { DatePickerModule } from 'primeng/datepicker';
import { SelectModule } from 'primeng/select';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

@Component({
  selector: 'app-call-by-dispatch-data',
  templateUrl: './call-by-dispatch.component.html',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './call-by-dispatch.component.scss',
  imports: [DatePickerModule, SelectModule, DatepickerComponent, DialogModule, TableModule, ToastModule, ConfirmPopupModule, TagModule, ButtonModule, InputTextModule, FormsModule, TableComponent, DropdownComponent, ProgressSpinnerModule, ConfirmPopupModule],
  providers: [MessageService, DistrictService, DatePipe, ConfirmationService],

})
export class CallByDispatchStatusComponent implements OnInit {
  @ViewChild('tblConfig') tblConfig!: TableComponent;

  router: any;
  param: any;
  processMessage: string = "";
  queryParamData: any = {};
  lsNorthDataColumns: any[] = [];
  criticalLoadDataCommentColumns: any[] = [];
  selectedItems: any[] = [];
  AppKeyValuePairs: any[] = [];
  actionButtons: any = [];
  isLoading: boolean = false;
  pageSize: number = 10;
  dialogVisible: boolean = false;
  cellValue: any[] = ['', ''];
  commentTable: any[] = [];
  // comments$: any[] = [];
  comments$!: Observable<any[]>;
  selectedRow: any;
  txtComment: any;
  user: any;
  districtOptions: SelectItem[] = [];
  schuduledDateOptions: SelectItem[] = [];
  dispatchViewOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  districtsMainCollection: any;
  selectedDistrict: string = "";
  selectedScheduledDate: string = "";
  selectedDispatchView: any;
  selectedType: any;
  allDistrictData: any[] = [];
  selectDate: string = "Sched Date";
  totalRecords: number = 0;
  pageNumber: number = 1;
  sortField: string = "SchedDate";
  sortOrder: number = 0;
  searchText: any = "";

  // filteredData: any[] = [...this.allDistrictData];
  filteredData$!: Observable<any[]>;
  selectedDateTaken: any;


  constructor(
    private route: ActivatedRoute,
    private recordsService: AllRecordsService,
    private messageService: MessageService,
    private redirectRoute: Router,
    private monotoringService: MyMonitoringService, private datePipe: DatePipe,
    private confirmationService: ConfirmationService, private apiService: ApiService
  ) {
    this.router = route;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      //  this.user = this.clsService.getUser();
      this.tblConfig.searchValue = this.param;

    });

    this.LoadHeader();
    this.LoadDistrictDetails();
    const temp = JSON.parse(sessionStorage.getItem("queryData")!);
    if (temp) {

      this.selectedDispatchView = temp.data.Dispatch_Status;
      this.selectedScheduledDate = temp.data.Sched_Date;
      this.selectedType = temp.data.Type;
      this.queryParamData = temp;

      this.getSelectedDistrictDetails();
      sessionStorage.removeItem("queryData")

    }

  }

  showDialog() {
    this.dialogVisible = true;
  }


  LoadHeader(): void {
    this.processMessage = environment.appMessages.loadingMesage;

    this.lsNorthDataColumns = [
      { "field": "DispatchStatus", "header": "DISPATCH STATUS", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "SchedDate", "header": "SCHED DATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Type", "header": "TYPE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "District", "header": "DISTRICT", "filter": true, "isSorting": true, "width": "10%" },

      { "field": "State", "header": "STATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "City", "header": "CITY", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "House", "header": "HOUSE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Street", "header": "STREET", "filter": true, "isSorting": true, "width": "10%" },
      {
        "field": "Update", "header": "ACTION", "filter": false, "isSorting": false, "width": "10%", type: "action", isClickable: 'true',
        onclick: this.handleClick.bind(this)
      }
    ];


    this.commentTable = [
      { "field": "message", "header": "USER COMMENTS", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdUser", "header": "CREATE BY", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdDate", "header": "CREATE DATETIME", "filter": true, "isSorting": true, "width": "5%" },
    ]

  }

  onDateTakenChange(event: any) {
    this.selectedDateTaken = event;
    //this.selectedType = '';
    //this.updateDropdownValues();
  }



  uniqueData(data: any) {
    const uniqueData = data.filter((value: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t.label === value.label && t.value === value.value
      ))
    );

    const sortedData = uniqueData.sort((a: any, b: any) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });

    return sortedData;
  }

  handleClick(rowData: any): void {
    this.redirectRoute.navigate(['/order-entry', rowData.CCR_ID]);

    const data = {

      Sched_Date: this.selectedScheduledDate,
      Dispatch_Status: this.selectedDispatchView,
      Type: this.selectedType
    }


    const temp = {
      data,
      from: "/bydispatchstatus"
    }

    sessionStorage.setItem("queryData", JSON.stringify(temp))
  }

  LoadDistrictDetails(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;

    this.apiService.groupId().pipe(
      switchMap(groupId => this.recordsService.getDistricts(groupId))
    ).subscribe({
      next: (data: any) => {
        this.districtsMainCollection = data?.Payload;
        this.dispatchViewOptions = this.uniqueData(data?.Payload?.DispatchStatusData.map((district: any) => ({
          label: district.Value.trim(),
          value: district.Value
        })))

        this.typeOptions = this.uniqueData(data?.Payload.OrderTypeData.map((district: any) => ({
          label: district.Value.trim(),
          value: district.Value
        })));

        this.isLoading = false;
        this.updateDropdownValues();

        if (this.queryParamData) {
          this.updateDropdownValuesForLoad();
          this.queryParamData = undefined;
        }
      },
      error: error => {
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallByDispatchStatusComponent.LoadDistrictDetails', message: error }, SeverityLevel.Error);
        this.isLoading = false;
      },
      complete: () => { this.isLoading = false; }
    });
  }

  sortedData(data: any[]) {
    return data.sort((a, b) => {
      const dateA = new Date(a.value);
      const dateB = new Date(b.value);
      return dateA.getTime() - dateB.getTime(); // Compare the numeric time values of the Date objects
    });
  }

  removeDuplicateValues(data: any) {
    return data.reduce((acc: any, current: any) => {
      if (!acc.some((item: any) => item.label === current.label)) {
        acc.push(current);
      }
      return acc;
    }, []);
  }

  updateDropdownValuesForLoad() {
    const tempData = this.districtsMainCollection?.filter((item: any) => item.DispatchStatus?.trim() === this.selectedDispatchView?.trim());
    const scheduledDta = this.uniqueData(tempData.map((district: any) => ({
      label: this.datePipe.transform(new Date(district.SchedDate.trim()), "MM-dd-yyyy")?.toString(),
      value: district.SchedDate?.trim()?.toString()
    })));
    const sortedScheduledData = this.sortedData(scheduledDta);
    this.schuduledDateOptions = this.removeDuplicateValues(sortedScheduledData?.reverse());
  }


  updateDropdownValues() {
    if (this.selectedDispatchView !== "" && this.selectedScheduledDate === "" && this.selectedType === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.DispatchStatus?.trim() === this.selectedDispatchView?.trim());
      const scheduledDta = this.uniqueData(tempData.map((district: any) => ({
        label: this.datePipe.transform(new Date(district.SchedDate.trim()), "MM-dd-yyyy")?.toString(),
        value: district.SchedDate?.trim()?.toString()
      })));
      const sortedScheduledData = this.sortedData(scheduledDta);
      this.schuduledDateOptions = this.removeDuplicateValues(sortedScheduledData?.reverse());
    }
  }

  getSelectedDistrictDetails(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true

    this.apiService.groupId().pipe(
      switchMap(groupId => {
        const payload = {
          Sched_Date: this.selectedDateTaken === "" ? null : this.selectedDateTaken,
          Dispatch_Status: this.selectedDispatchView === "" ? null : this.selectedDispatchView,
          Type: this.selectedType === "" ? null : this.selectedType,
          UserID: sessionStorage.getItem('userId'),
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          SortField: this.sortField,
          SortOrder: this.sortOrder,
          SearchText: this.searchText,
          groupId: groupId,
          HasDispatchStatus: true
        }
        return this.recordsService.getRecordDetails(payload);
      })
    ).subscribe({
      next: (data: any) => {
        const updatedData = data?.Payload.Data?.map((item: any) => {
          return {
            ...item,
            SchedDate: this.datePipe.transform(new Date(item.SchedDate.trim()), "MM-dd-yyyy")?.toString()
          }
        });
        this.filteredData$ = of(updatedData);
        this.isLoading = false;
        this.totalRecords = data?.Payload?.TotalRecords;
        if (data?.Payload?.Data?.length === 0) {
          const errMsg = environment.appMessages.noData
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: errMsg, life: environment.appSettings.snakbarLife });
        }
      },
      error: error => {
        this.isLoading = false;
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallByDispatchStatusComponent.getSelectedDistrictDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;

      }
    });
  }

  onCellClicked(event: any[]) {
    this.isLoading = true;
    this.cellValue = event;
    this.selectedRow = event[1];
  }

  handlePageChange(event: any): void {
    this.pageNumber = event.page;
    this.pageSize = event.pageSize;
    this.getSelectedDistrictDetails();
  }


  onCancelCommentClicked() {
    this.txtComment = "";
    this.dialogVisible = false;
  }

  onSaveCommentClicked() {
    this.isLoading = true;
    const cmt = { bqUniqueId: this.selectedRow.bqUniqueId, message: this.txtComment, createdUser: this.user, createdDate: Date() };
    if (cmt === null || cmt === undefined) {
      this.messageService.add({ severity: 'warning', summary: 'warning', detail: environment.appMessages.noChangesFound, life: environment.appSettings.snakbarLife });
      return;
    }
    this.processMessage = environment.appMessages.savinggMesage;
    this.isLoading = false;
  }

  reload() {
    this.tblConfig.clear();
    this.selectedItems = [];
    this.LoadHeader();
  }

  onReloadClicked() {
    this.reload();
  }

  onScheduledDateChange(event: any) {
    this.selectedScheduledDate = event;
  }

  onDispatchViewChange(event: any) {
    this.selectedDispatchView = event;
  }

  getSearchDisabledStatus() {
    return this.selectedDispatchView === "" || this.selectedScheduledDate === "" || this.selectedType === ""
  }

  onTypeChange(event: any) {
    this.selectedType = event;
  }

  onSearch(): void {
    this.pageNumber = 1
    this.tblConfig.resetPage();
    this.getSelectedDistrictDetails();
  }

  onClear(): void {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {
        this.selectedScheduledDate = "";
        this.selectedType = "";
        this.selectedDateTaken = "";
        this.selectedDispatchView = "";
        this.sortField = "";
        this.sortOrder = 1;
        this.searchText = "";
        this.filteredData$ = of([]);
        this.totalRecords = 0
      },
    });
  }

  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.searchText = event.searchText;
    this.getSelectedDistrictDetails();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.getSelectedDistrictDetails();
  }
}




